import { render, staticRenderFns } from "./c-info-yxkh-list.vue?vue&type=template&id=3e248263&scoped=true"
import script from "./c-info-yxkh-list.vue?vue&type=script&lang=js"
export * from "./c-info-yxkh-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e248263",
  null
  
)

export default component.exports